module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-top-panel-1-352a7e4ce6d5aa0e37b33225a50756d3.svg";